import React from 'react'
import '../stylesheets/bottom-row.sass'

export const BottomRow = (props) => {
  return (
    <div className={`${props.extra_class} ${props.widthClass}`}>
      <div className={'column-one bottom-row-col'}>
        &nbsp;
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/shared/BottomRow.jsx